import { ServiceFetch } from '../service-fetch'

export default class CustomerModel extends ServiceFetch {
    generateCustomerLastCode = (data) => this.authFetch({
        url: 'customer/generateCustomerLastCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerBy = (data) => this.authFetch({
        url: 'customer/getCustomerBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getCustomerByCode = (data) => this.authFetch({
        url: 'customer/getCustomerByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })

    checkCustomerTelBy = (data) => this.authFetch({
        url: 'customer/checkCustomerTelBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateCustomerBy = (data) => this.authFetch({
        url: 'customer/updateCustomerBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    insertCustomer = (data) => this.authFetch({
        url: 'customer/insertCustomer',
        method: 'POST',
        body: JSON.stringify(data),
    })
}